import { User } from "../api/types";

export type IdentityOptions = {
  username?: string;
  firstName?: string;
  lastName?: string;
  anonymous_id?: string | null;
};

export const trackEvent = (event: string, properties = {}) => {
  if (
    typeof window.pendo !== "undefined" &&
    process.env.REACT_APP_PENDO_ENABLED
  ) {
    window.pendo.track(event, properties);
  }
};

export const identifyUserPendo = (user: User) => {
  if (
    typeof window.pendo === "undefined" ||
    !process.env.REACT_APP_PENDO_ENABLED ||
    !user
  ) {
    return;
  }

  const today = new Date();
  const accountCreationDate = (
    user.account_creation_date ?? today.toISOString()
  ).slice(0, 10);
  const userSegment = `${user.user_type} (${user.business_type_short_form})`;

  const emailDomain = user.email?.split("@")[1]?.split(".")[0]?.toLowerCase();
  const isInternalUser = emailDomain === "quandl" || emailDomain === "nasdaq";
  const pendoUserId = isInternalUser ? `emp-${user.id}` : user.id;

  // Retrieve previous Pendo visitor ID from cookies
  const cookies = decodeURIComponent(document.cookie).split(";");
  const oldVisitorCookie = cookies.find(c =>
    c.trim().startsWith("_pendo_visitorId")
  );
  const oldVisitorId = oldVisitorCookie
    ? oldVisitorCookie.split("=")[1].trim()
    : null;

  const account = {
    id: user.customer_id ?? pendoUserId,
    accountCreationDate,
    userSegment,
    firm_size: user.number_of_employee_title,
    employee: isInternalUser ? "Yes" : "No"
  };

  if (oldVisitorId) {
    window.pendo.identify({ visitor: { id: oldVisitorId }, account });
  }
  window.pendo.identify({ visitor: { id: pendoUserId }, account });
};
